module.exports = __webpack_public_path__ + "img/烟花.c9544699.svg";